import PolicyLayout, { Section } from "@/components/site/PolicyLayout";
import usePageMeta from "@/hooks/usePageMeta";

export default function Disclaimer() {
  usePageMeta({
    title: "Disclaimer | RUDRA EMPIRE",
    description:
      "Disclaimer — the notices that clarify what www.rudraempire.com represents, and what it does not.",
    canonical: "https://rudraempire.com/disclaimer",
  });
  return (
    <PolicyLayout
      eyebrow="Policy · III"
      title="Disclaimer"
      italic="&amp; Notices."
      lastUpdated="August 2026"
    >
      <p className="text-lg text-neutral-200 italic">
        RUDRA EMPIRE operates in the sensitive domain of land. The following
        notices clarify what this website represents, and what it does not.
      </p>

      <Section number="01" title="Informational Only">
        <p>
          The material on www.rudraempire.com is published for general information about RUDRA EMPIRE, its history, its team, and the nature of its work. It is <span className="text-neutral-100">not</span> an offer, solicitation, prospectus, or invitation to invest in, buy, sell, lease, or otherwise deal in land, securities, or any financial instrument.
        </p>
      </Section>

      <Section number="02" title="No Advice">
        <p>
          Nothing on this website constitutes legal, tax, investment, financial, or real-estate advice. Land acquisition and disposition are complex, jurisdiction-specific matters. You should always seek independent professional counsel before entering into any transaction.
        </p>
      </Section>

      <Section number="03" title="Figures & Projections">
        <p>
          Any financial or operational figures referenced on this website — including revenue milestones, pipeline value, historical turnover, area under management, or timelines — are indicative and derived from internal records. They are subject to revision and audit and should not be relied upon as the basis of any commercial decision without direct written confirmation from an authorised officer of the firm.
        </p>
      </Section>

      <Section number="04" title="Client & Partner References">
        <p>
          The names of Government bodies, multinational corporations, and other institutions that appear in illustrative pipeline material are used only to describe the general nature of RUDRA EMPIRE's work and mandates. Their inclusion does not imply endorsement, sponsorship, or a subsisting commercial relationship, and does not confer any rights on any third party.
        </p>
      </Section>

      <Section number="05" title="Forward-Looking Statements">
        <p>
          The website may contain forward-looking language about the firm's plans, projects, or ambitions. Such statements involve inherent uncertainty. Actual outcomes may differ. RUDRA EMPIRE undertakes no obligation to update any forward-looking statement in light of future events.
        </p>
      </Section>

      <Section number="06" title="Images & Locations">
        <p>
          Photographs of Karnataka landscapes and other visuals are used editorially. They may not depict the specific parcels or districts referenced in adjacent text.
        </p>
      </Section>

      <Section number="07" title="No Warranty of Accuracy">
        <p>
          While we take reasonable care to keep the content of this website accurate, RUDRA EMPIRE makes no representation or warranty regarding the completeness, timeliness, or accuracy of the information provided, and disclaims all liability for any reliance placed on it.
        </p>
      </Section>

      <Section number="08" title="Contact">
        <p>
          For any clarification concerning material on this website, please write to{" "}
          <a className="link-gold text-neutral-100" href="mailto:info@rudraempire.com">info@rudraempire.com</a>.
        </p>
      </Section>
    </PolicyLayout>
  );
}
